export default function () {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7177_93556)">
                <path
                    d="M7.85315 6.18044C7.85315 6.18044 5.62789 15.4473 5.07222 20.8984C4.51654 26.3495 7.29748 27.9849 8.96449 27.9849H19.5223C21.1893 27.9849 26.1903 28.53 26.746 23.0789C27.1905 18.718 24.9653 9.4511 24.5233 7.27066C24.0813 5.09022 23.4116 4 21.7449 4H10.6315C8.85336 4 8.03837 5.45363 7.85315 6.18044Z"
                    stroke="black"
                    strokeWidth="1.2"
                />
                <path d="M18.0859 16.5371H26.2626" stroke="black" strokeWidth="1.2" />
                <path d="M6.09375 16.5371H13.7253" stroke="black" strokeWidth="1.2" />
                <rect x="13.7188" y="14.9023" width="4.36088" height="10.9022" rx="2.18044" stroke="black" strokeWidth="1.2" />
                <ellipse cx="15.9027" cy="7.27088" rx="1.09022" ry="1.09022" stroke="black" strokeWidth="0.872176" />
                <ellipse cx="15.9027" cy="11.6312" rx="1.09022" ry="1.09022" stroke="black" strokeWidth="0.872176" />
            </g>
            <defs>
                <clipPath id="clip0_7177_93556">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
